import { useState } from 'react'

const Dashboard = () => {
  const [stats] = useState({
    total_afectados: 0,
    total_donaciones: 0,
    total_voluntarios: 0,
    total_pendientes: 0
  })

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">📊 Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Afectados</p>
              <p className="text-2xl font-bold text-gray-900">{stats.total_afectados}</p>
            </div>
            <span className="text-3xl">👥</span>
          </div>
        </div>
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Donaciones</p>
              <p className="text-2xl font-bold text-gray-900">{stats.total_donaciones}</p>
            </div>
            <span className="text-3xl">📦</span>
          </div>
        </div>
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Voluntarios</p>
              <p className="text-2xl font-bold text-gray-900">{stats.total_voluntarios}</p>
            </div>
            <span className="text-3xl">🧑</span>
          </div>
        </div>
        <div className="card p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">Pendientes</p>
              <p className="text-2xl font-bold text-gray-900">{stats.total_pendientes}</p>
            </div>
            <span className="text-3xl">⏳</span>
          </div>
        </div>
      </div>

      <div className="card p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-2">Bienvenido a Rutas de Solidaridad</h3>
        <p className="text-gray-600">Dashboard en construcción. Próximamente: mapa de necesidades, alertas y más.</p>
      </div>
    </div>
  )
}

export default Dashboard